// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"cfa782e5","732":"331fa44c","977":"be669fb7"}[chunkId] + ".chunk.js");